import { oneApi } from 'config/api'

export default {
  props: {
    // 吸顶状态
    stickyStatus: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      locale: this.$store.state.locale,
      langContext: this.$t('featureComponents.Header'),
      userNavigationLinks: [
        {
          name: 'Shopping Cart',
          url: '/shopping-cart',
          target: '',
        },
        {
          name: 'My Orders',
          url: '/order/list',
          target: '',
        },
        {
          name: 'Unpaid Courses',
          url: '/my-unpaid-courses/list',
          target: '',
          mark: true,
        },
        {
          name: 'My Account',
          url: '/settings',
          target: '',
        },
        {
          name: 'Sign Out',
          url: '',
          target: '',
          isLink: false,
        },
      ],
      campusNavList: [
        {
          name: 'Cupertino, CA',
          url: '/campuses/cupertino',
          lat: 37.30714227875363,
          lng: -122.03266038727122,
          // lat: 40.1049346951878,
          // lng: 116.30858611791325,
        },
        {
          name: 'Los Altos, CA',
          url: '/campuses/los-altos',
          lat: 37.397233912852286,
          lng: -122.10594913145032,
        },
        {
          name: 'Irvine, CA',
          url: '/campuses/irvine',
          lat: 33.69325888612016,
          lng: -117.76890120274233,
        },
        {
          name: 'Bellevue, WA',
          url: '/bellevue/summer',
          lat: 47.627553569969756,
          lng: -122.17057973103854,
        },
      ],
      longLat: {
        // long: 40.104934698994526,
        // lat: 116.30858611429599,
        long: '',
        lat: '',
      },
      siteJumpUrl: '/', // 站点跳转链接
      schoolName: 'Find my school',
      targetUrl: ['/mathgame', 'https://www.thethinkacademy.com/mathgame'],
      // 是否有作业入口
      isHaveHomework: false,
      // 是否展示作业提示
      isShowHomeworkTip: false,
      // 临时token
      TempToken: '',
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.ucenter.isLogin;
    },
    userInfo() {
      return this.$store.state.ucenter.user
    },
    currentRoutePath() {
      return this.$route.path
    },
    navigationLinks() {
      return this.$store.state.website.header.navigationLinks
    },
    // 主导航列表
    mainNavList() {
      return this.navigationLinks.filter((item) => (item.navigation && item.navigation === 1) || !item.navigation)
    },
    // 主导航列表
    // campusNavList() {
    //   const campus = this.navigationLinks.find((item) => item.name === 'Campus' || item.name === 'Campuses')
    //   if (campus && campus.children) {
    //     const latMap = [

    //     ]
    //     return campus.children
    //   }
    //   return []
    // },
    // 一级导航
    firstNavList() {
      return this.navigationLinks.filter((item) => item.navigation && item.navigation === 3)
    },
    ceilingList() {
      return this.$store.state.customPage.pageModuleList.filter((item) => item.type === 66)
    },
    logoUrl() {
      const { config } = this.$store.state.website || {}
      return process.env.clientType === 'web' ? (config.logo || this.$t('common.logo.normal')) : (config.whiteLogo || this.$t('common.logo.normalWhite'))
    },
    isWebClient() {
      return process.env.clientType === 'web'
    },

    schoolCode() {
      return this.$store.state.schoolCode;
    },
    secondNavList() {
      if (typeof window === 'undefined') return [];
      // 先检查 firstNavList 是否存在
      if (!this.firstNavList) {
        return [];
      }
      // 查找匹配的路由
      const findRoute = this.firstNavList.find((item) => item.url === this.currentRoutePath || item.url === this.currentLocationUrl);
      // 安全地返回子路由列表
      if (findRoute && findRoute.children) {
        return findRoute.children;
      }
      return this.mainNavList;
    },
    excludeMathGame() {
      const deepFilter = (items) => {
        if (!Array.isArray(items)) return []
        return items.reduce((filtered, current) => {
          const shouldExclude = current && current.url && this.targetUrl.includes(current.url)
          if (shouldExclude) {
            return filtered
          }
          const nextItem = { ...current }
          if (Array.isArray(current.children) && current.children.length) {
            nextItem.children = deepFilter(current.children)
          }
          filtered.push(nextItem)
          return filtered
        }, [])
      }
      return deepFilter(this.secondNavList)
    },
    showSchool() {
      const campusNavListUrl = this.campusNavList.map((item) => item.url);
      const targetUrl = [...campusNavListUrl, '/inperson'];
      return targetUrl.includes(this.currentRoutePath);
    },
    logoSrc() {
      return this.showSide ? this.$t('common.logo.white') : this.$t('common.logo.normal')
    },
    conversionComponents() {
      return this.navigationLinks.filter((item) => item.navigation && item.navigation === 5)
    },
    currentLocationUrl() {
      if (typeof window === 'undefined') return ''
      try {
        return window.sessionStorage.getItem('currentLocationUrl') || ''
      } catch (e) {
        return ''
      }
    },
  },
  watch: {
    currentRoutePath: {
      handler(newVal) {
        if (newVal) {
          const targetSchool = this.campusNavList.find((item) => item.url === newVal);
          if (targetSchool) this.schoolName = targetSchool.name;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    console.log('this.longLat.long', this.longLat.long, this.longLat.lat)
    console.log('!this.longLat.long && !this.longLat.lat', !this.longLat.long && !this.longLat.lat)
    this.getLocalLongLat();
    if (!this.longLat.long && !this.longLat.lat) {
      this.getLongLat();
    } else {
      this.setCampusesWithDistance();
    }
  },
  methods: {
    handleClickNav(name, url = '') {
      console.log('name', name, url)
      if (url) {
        window.sessionStorage.setItem('currentLocationUrl', url);
      }
      this.Sensors.track('component_click', {
        component_name: name,
      })
    },
    getDistance(lat1, lon1, lat2, lon2) {
      const R = 6371; // 地球半径（单位：公里）
      const dLat = ((lat2 - lat1) * Math.PI) / 180; // 纬度差转弧度
      const dLon = ((lon2 - lon1) * Math.PI) / 180; // 经度差转弧度
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
        + Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180)
        * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c; // 最终距离（公里）
      return distance;
    },
    // 为校区数据添加距离字段的函数
    addDistanceToCampuses(campuses, currentLat, currentLng) {
      return campuses.map((campus) => {
        // 计算当前位置到校区的距离
        const distance = this.getDistance(
          currentLat,
          currentLng,
          campus.lat,
          campus.lng,
        );
        // 返回包含距离字段的新校区对象
        return {
          ...campus,
          distance: distance.toFixed(2), // 保留两位小数
        };
      });
    },
    getLongLat() {
      console.log('navigator', navigator)
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showmap, this.error);
      } else {
        sessionStorage.setItem('geoRedirected', 'true');
      }
    },
    showmap(position) {
      const cords = position.coords;
      this.longLat.long = cords.longitude; // 经度
      this.longLat.lat = cords.latitude; // 纬度
      window.sessionStorage.setItem('currentLocationLat', cords.latitude);
      window.sessionStorage.setItem('currentLocationLng', cords.longitude);
      console.log('获取经纬度成功', this.longLat)
      this.setCampusesWithDistance();
    },
    error(error) {
      sessionStorage.setItem('geoRedirected', 'true');
      switch (error.code) {
        case error.PERMISSION_DENIED:
          console.log('用户拒绝了位置请求');
          break;
        case error.POSITION_UNAVAILABLE:
          console.log('位置信息不可用');
          break;
        case error.TIMEOUT:
          console.log('请求位置超时');
          break;
        case error.UNKNOWN_ERROR:
          console.log('发生未知错误');
          break;
        default:
          console.log('获取失败')
      }
    },
    toEvaluation() {
      if (!this.isLogin) {
        this.handleLogin();
      }
    },
    handleSchoolClick(item) {
      console.log('item', item)
      window.localStorage.setItem('TeachingPoints', item.name);
    },
    getLocalLongLat() {
      this.longLat.long = window.sessionStorage.getItem('currentLocationLng'); // 经度
      this.longLat.lat = window.sessionStorage.getItem('currentLocationLat'); // 纬度
    },
    setCampusesWithDistance() {
      const campusesWithDistance = this.addDistanceToCampuses(this.campusNavList, this.longLat.lat, this.longLat.long);
      console.log('campusesWithDistance', campusesWithDistance)
      this.campusNavList = campusesWithDistance;
      this.checkLocationAndRedirect(campusesWithDistance);
    },
    checkLocationAndRedirect(list) {
      const withinDistance = this.hasNearbyLocation(list);
      console.log('withinDistance', withinDistance);
      if (withinDistance) this.schoolName = withinDistance.name;
      // 防止重复重定向
      if (this.currentRoutePath === '/' && !sessionStorage.getItem('geoRedirected')) {
        sessionStorage.setItem('geoRedirected', 'true');
        if (withinDistance) {
          this.$router.push(withinDistance.url);
        }
      }
    },
    // 寻找距离最近的小区 （阈值是30公里）
    hasNearbyLocation(locations) {
      return locations
        .filter((location) => {
          const { distance } = location;
          return distance !== undefined && distance !== '' && parseFloat(distance) <= 30;
        })
        .reduce((closest, current) => {
          const currentDist = parseFloat(current.distance);
          return (closest === undefined || currentDist < parseFloat(closest.distance))
            ? current
            : closest;
        }, undefined);
    },
    async isCheckHaveHomework() {
      try {
        const res = await this.$axios.post(oneApi.checkHomework, {}, { rewritePostBody: true })
        if (!this.isLogin) {
          return
        }
        if (res.code !== 0) {
          this.$ElMessage.error(res.msg)
          return
        }
        this.isHaveHomework = res.data.homeworkEntrance
        this.isShowHomeworkTip = res.data.unfinishedHomework
      } catch (error) {
        console.error('error', error);
      }
    },
    async getTempToken() {
      try {
        const res = await this.$axios.post(oneApi.getTempToken, {}, { rewritePostBody: true, headerToken: true })
        if (res.code !== 0) {
          this.$ElMessage.error(res.msg)
          return
        }
        this.TempToken = res.data
      } catch (error) {
        console.error('error', error);
      }
    },
  },
}
